// Formatering av selgeropplysninger på kundesidene (betalingssiden og salgsvilkårene).

/** 123456789 → «123 456 789», slik org.nr. skrives i Brønnøysundregistrene. */
export function formatOrgnr(orgnr: string): string {
  const d = orgnr.replace(/\D/g, '');
  return d.length === 9 ? `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}` : orgnr;
}

/** Adressen kan være lagret over flere linjer; i bunnteksten står den på én. */
export function oneLineAddress(address: string): string {
  return address
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean)
    .join(', ');
}
